/*
  Triggers floodlight events using javascript. Original scripts are located in originalFloodlightScripts.txt for reference
*/
var DealerResultsEvents = {
  buttonUrl : '',
  buttonAction : false,
  actionId : 0,
  source : '',
  type : '',
  buttonEvent : '',
  debug: false, // set debug mode by pasting the following in console DealerResultsEvents.debug = true
  init : function(buttonEvent, action, button, source, type) {
    this.current_language = floodlight_dr.current_language;
    this.buttonAction = action;
    this.buttonUrl = $(button).attr('href');
    this.source = source;
    this.type = type;
    this.buttonEvent = buttonEvent;
    this.dealerName = $(button).parents('.singleDealerResult').data('title');
    this.dealerSlug = $(button).parents('.singleDealerResult').data('slug');
    this.data_dealer = $(button).data('dealer');
    // check if debug GET parameter is available to debug floodlight tags
    if (this.findGetParameter('debug')) {
      this.debug = true;
    }

    var axel = Math.random() + "";
    var a = axel * 10000000000000;
    this.actionId = a;

    this.actionListeners();
  },
  findGetParameter : function(parameterName) {

      var result = null,
          tmp = [];
      location.search
          .substr(1)
          .split("&")
          .forEach(function (item) {
            tmp = item.split("=");
            if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
          });
      return result;
  },
  actionListeners : function() {
    var that = this,
        siteName = encodeURIComponent(that.dealerName);

    if (that.buttonAction) {
      var ftRand = Math.random() + "",
          num = ftRand * 1000000000000000000,
          eventData = {};
      switch(that.buttonAction) {
        case "website":
          if (that.current_language && that.current_language != 'en') {
            // spanish
            eventData = {
              floodlightCat: 'schda02x',
              flashtalkingURL: "https://servedby.flashtalking.com/spot/8/9586;87278;7489/?spotName=SCHDA_DI_Results_Website_SL&u1="+siteName+"&cachebuster="+num
            }
          }else {
            // english
            eventData = {
              floodlightCat: 'schda02w',
              flashtalkingURL: "https://servedby.flashtalking.com/spot/8/9586;87275;7489/?spotName=SCHDA_DI_Results_Website_EL&u1="+siteName+"&cachebuster="+num
            }
          }
        break;
        case "mapwebsite":
          if (that.current_language && that.current_language != 'en') {
            // spanish
            eventData = {
              floodlightCat: 'schda02t',
              flashtalkingURL: "https://servedby.flashtalking.com/spot/8/9586;87276;7489/?spotName=SCHDA_DI_Map_Visit_Website_SL&u1="+siteName+"&cachebuster="+num
            }
          } else {
            // english
            eventData = {
              floodlightCat: 'schda02s',
              flashtalkingURL: "https://servedby.flashtalking.com/spot/8/9586;87273;7489/?spotName=SCHDA_DI_Map_Visit_Website_EL&u1="+siteName+"&cachebuster="+num
            }
          }
        break;
        case "newinventory":
          if (that.current_language && that.current_language != 'en') {
            // spanish
            eventData = {
              floodlightCat: 'schda01e',
              flashtalkingURL: "https://servedby.flashtalking.com/spot/8/9586;77215;7489/?spotName=SCHDA_New_Inventory_SL&u1="+siteName+"&cachebuster="+num
            }
          } else {
            // english
            eventData = {
              floodlightCat: 'schda01d',
              flashtalkingURL: "https://servedby.flashtalking.com/spot/8/9586;77214;7489/?spotName=SCHDA_New_Inventory_EL&u1="+siteName+"&cachebuster="+num
            }
          }
        break;
        case "usedinventory":
          if (that.current_language && that.current_language != 'en') {
            // spanish
            eventData = {
              floodlightCat: 'schda01k',
              flashtalkingURL: "https://servedby.flashtalking.com/spot/8/9586;77216;7489/?spotName=SCHDA_Used_Inventory_SL&u1="+siteName+"&cachebuster="+num
            }
          } else {
            // english
            eventData = {
              floodlightCat: 'schda01j',
              flashtalkingURL: "https://servedby.flashtalking.com/spot/8/9586;77217;7489/?spotName=SCHDA_Used_Inventory_EL&u1="+siteName+"&cachebuster="+num
            }
          }
        break;
        case "mapgetdirections":
          if (that.current_language && that.current_language != 'en') {
            // spanish
            eventData = {
              floodlightCat: 'schda02v',
              flashtalkingURL: "https://servedby.flashtalking.com/spot/8/9586;87277;7489/?spotName=SCHDA_DI_Map_Get_Directions_SL&u1="+siteName+"&cachebuster="+num
            }
          } else {
            // english
            eventData = {
              floodlightCat: 'schda02u',
              flashtalkingURL: "https://servedby.flashtalking.com/spot/8/9586;87274;7489/?spotName=SCHDA_DI_Map_Get_Directions_EL&u1="+siteName+"&cachebuster="+num
            }
          }
        break;
        case "getdirections":
          if (that.current_language && that.current_language != 'en') {
            // spanish
            eventData = {
              floodlightCat: 'schda01c',
              flashtalkingURL: "https://servedby.flashtalking.com/spot/8/9586;77220;7489/?spotName=SCHDA_Get_Directions_SL&u1="+siteName+"&cachebuster="+num
            }
          } else {
            // english
            eventData = {
              floodlightCat: 'schda01b',
              flashtalkingURL: "https://servedby.flashtalking.com/spot/8/9586;77221;7489/?spotName=SCHDA_Get_Directions_EL&u1="+siteName+"&cachebuster="+num
            }
          }
        break;
        case "scheduleservice":
          if (that.current_language && that.current_language != 'en') {
            // spanish
            eventData = {
              floodlightCat: 'schda01i',
              flashtalkingURL: "https://servedby.flashtalking.com/spot/8/9586;77223;7489/?spotName=SCHDA_Schedule_Service_SL&u1="+siteName+"&cachebuster="+num
            }
          } else {
            // english
            eventData = {
              floodlightCat: 'schda01h',
              flashtalkingURL: "https://servedby.flashtalking.com/spot/8/9586;77222;7489/?spotName=SCHDA_Schedule_Service_EL&u1="+siteName+"&cachebuster="+num
            }
          }
        break;
        case "requestaquote":
          if (that.current_language && that.current_language != 'en') {
            // spanish
            eventData = {
              floodlightCat: 'schda01g',
              flashtalkingURL: "https://servedby.flashtalking.com/spot/8/9586;77219;7489/?spotName=SCHDA_Request_A_Quote_SL&u1="+siteName+"&cachebuster="+num
            }
          } else {
            // english
            eventData = {
              floodlightCat: 'schda01f',
              flashtalkingURL: "https://servedby.flashtalking.com/spot/8/9586;77218;7489/?spotName=SCHDA_Request_A_Quote_EL&u1="+siteName+"&cachebuster="+num
            }
          }
        break;
        case "footer-locations":
          if (that.current_language && that.current_language != 'en') {
            // spanish
            eventData = {
              floodlightCat: 'schda02z',
              flashtalkingURL: "https://servedby.flashtalking.com/container/9586;111564;7489;iframe/?spotName=SCHDA_DI_Dealership_DT_Footer__SL&cachebuster="+num
            };
            siteName = this.data_dealer;
          }
          else{
            // english
            eventData = {
              floodlightCat: 'schda02y',
              flashtalkingURL: "https://servedby.flashtalking.com/container/9586;111563;7489;iframe/?spotName=SCHDA_DI_Dealership_DT_Footer_EL&cachebuster="+num
            };
            siteName = this.data_dealer;
          }
        break;
      }
      that.processEvent(eventData, siteName);

      return false;
    }
  },
  processEvent : function(data, siteName) {
    var that = this;
    var source = that.source;
    var type = that.type;
    var flashtalkingURL = btoa(data.flashtalkingURL);
    var redirect = btoa(that.buttonUrl);

    var floodlightRedirectURL = '/fl/' + data.floodlightCat + '/?type=' + type + '&redirect=' + redirect + '&src=' + source + '&flashtalkingurl=' + flashtalkingURL + '&sitename='+siteName;

    if (that.debug) {
      floodlightRedirectURL += '&debug=true';
    }

    window.location.href = floodlightRedirectURL;
  }
}

// Floodlight implementation
jQuery(document).ready(function($) {
  $('body').on('click', '.dealerResultsList .singleDealerResult a[data-action], #map a[data-action], .tier-3-sitelink', function(e) {

    if ($(this).data('action')) {
      DealerResultsEvents.init(e, $(this).data('action'), this, '1371709', 'inspire0');
      return false;
    }
  });
});
